module.exports = __webpack_public_path__ + "img/Menu_Icons-10.cae142aa.svg";